import Glide from '@glidejs/glide'
import initTabs from './tabs';
import initAccordions from './accordions';
import initTeamModals from './teamModals';
import initPartnershipTabs from './partnershipTabs';
import initHotspotModals from './hotspotModals';
import initNewsFilter from './newsFilter';

initTabs();
initAccordions();
initTeamModals();
initPartnershipTabs();
initHotspotModals();
initNewsFilter();

const newsCarousel = new Glide('.home-news-carousel', {
    type: 'slider',
    perView: 3,
    peek: {
        before: calculatePeek(),
        after: 100,
    },
    gap: 20,
    breakpoints: {
        768: {
            perView: 1,
            peek: {
                before: 32,
                after: 100,
            },
        },
        1024: {
            perView: 2,
            peek: {
                before: 32,
                after: 100,
            },
        },
        1339: {
            peek: {
                before: 32,
                after: 100,
            },
        }
    }
}).mount()

function calculatePeek() {
    console.log(window.innerWidth / 2 - 1340 / 2);
    return window.innerWidth / 2 - 1340 / 2 + 32;
}

// Debounce utility function
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Debounced resize handler
const debouncedResizeHandler = debounce(() => {
    if (window.innerWidth >= 1340) {
        homeNewsCarousel.update({
            peek: {
                before: calculatePeek(),
                after: 100,
            }
        });
    } else {
        homeNewsCarousel.update({
            peek: {
                before: 32,
                after: 100,
            }
        });
    }
}, 250); // 250ms delay

window.addEventListener('resize', debouncedResizeHandler);


// Logo slider with auto-play and loop
new Glide('.partners-logo-slider', {
    type: 'carousel',
    perView: 5,
    autoplay: 3000,
    hoverpause: true,
    gap: 40,
    loop: true,
    breakpoints: {
        768: {
            perView: 3,
        },
        1024: {
            perView: 4,
        }
    }
}).mount()

if (document.querySelector('.testimonial-glide')) {
    new Glide('.testimonial-glide').mount()
}

let heroVideoButton = document.querySelector('.home-hero-video-button');

if (heroVideoButton) {
    heroVideoButton.addEventListener('click', (e) => {

        let video = document.querySelector('.home-hero-video');

        if (!video.paused) {
            video.pause();
            heroVideoButton.classList.add('paused');
        } else {
            video.play();
            heroVideoButton.classList.remove('paused');
        }
    });
}


